import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`join us!`}</h2>
    <p>{`We are most active on `}<a parentName="p" {...{
        "href": "https://t.me/ethafricahub"
      }}>{`Telegram`}</a>{`! And you can also find us on `}<a parentName="p" {...{
        "href": "https://twitter.com/ethafricahub"
      }}>{`Twitter`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      